import List from "./components/List"

let module = "reports"

export default [
  {
    path: "reports",
    component: List,
    meta: { module: module, permissions: ["all"] }
  }
]
